import Section from "../../components/Common/Section";
import Heading from "../../components/Common/Heading";
import Divider from "../../components/Common/Divider";
import ApiStatus from "../../components/ApiStatus";
import useFetchIzobrazevanjeAll from "./IzobrazevanjeHooks";
import IzobrazevanjeListTableFiltri from "./IzobrazevanjeListTableFiltri";
import { IzobrazevanjeVrsta } from "../../utils/Enums";

const IzobrazevanjeList = () => {

    const { data, status, isSuccess } = useFetchIzobrazevanjeAll();

    if (!isSuccess)
        return (
            <Section>
                <Heading>Pregled izobraževanj
                    <Divider />
                </Heading>
                <ApiStatus status={status}></ApiStatus>
            </Section>
        )

    return (
        <Section>
            <Heading>
                Pregled izobraževanj
                <Divider />
            </Heading>
            <IzobrazevanjeListTableFiltri
                izobrazevanjeListData={data}
                izobrazevanjeVrsta={IzobrazevanjeVrsta.Navadno}
            />
        </Section>
    );
}

export default IzobrazevanjeList;
